module.exports = __webpack_public_path__ + "img/facial_hair_full_beard_thick_average_mask.209cc6e3.png";